export default class FootballBadgeRequirements {
  public predictionsNumber: number;
  public correctPredictions: number;
  public points: number;
  public entityId: string;
  public entityType: string;
  public entityModel: any = null;
}
